import {
  ProfileActionId,
  FrontDeskId,
  HeaderId,
  RouteItemId,
  BreadcrumbId,
} from 'common/enums/html.enums';

export const HEADER_IDS = Object.values(HeaderId);
export const ROUTE_ITEM_IDS = Object.values(RouteItemId);
export const BREADCRUMB_IDS = Object.values(BreadcrumbId);
export const FRONT_DESK_IDS = Object.values(FrontDeskId);
export const PROFILE_ACTION_IDS = Object.values(ProfileActionId);
